<div class="relative h-100vh  min-h-screen">
    <div class="h-100vh !px-3 pt-3 pb-6 overflow-y-scroll">
        <app-loader @fadeIn *ngIf="isLoading"></app-loader>

        <div class="flex items-center justify-center mb-4">
            <div class="bg-grey/40 shadow font-medium text-primary px-3 py-2 rounded-full border">
                {{ selectedRole?.roleName }}
            </div>
        </div>

        <div class="flex items-center border rounded-lg p-4">
            <div class="flex-grow">
                <mat-form-field appearance="outline" class="w-full">
                    <input
                            matInput
                            autocomplete="off"
                            (input)="searchServiceType($event)"
                    />
                    <mat-label>Search Permissions</mat-label>
                </mat-form-field>
            </div>


        </div>
        <mat-accordion multi>
            <mat-expansion-panel @fadeIn *ngFor="let grouped of allPermissionsNew; let idx = index" [expanded]="true">
                <mat-expansion-panel-header class="bg-primary-50/40 border-b border-primary">
                    <mat-panel-title class="!text-primary">
                        {{ idx + 1 }}. {{ grouped.groupName }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="grid grid-cols-12">
                    <div class="col-span-12 md:col-span-4 " *ngFor="let permission of grouped.groupPermissions">
                        <mat-checkbox
                                (change)="onChange(permission.uniqueId, $event)"
                                [checked]="hasPermission(permission.uniqueId)"
                                [value]="permission.uniqueId"
                                [title]="permission.permissionCode"
                                style="color: #005590;"
                                >{{ formatPermissionName(permission.permissionName) }}
                        </mat-checkbox>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="bottom-0 right-0 absolute flex items-end justify-end">
        <button
                (click)="saveChanges()"
                mat-fab [disabled]="!formChanged" color="primary" class="absolute top-0 right-0 " style="background-color: #005590;">
            <mat-icon style="color: white">save</mat-icon>
        </button>
    </div>
</div>

